export default "__VITE_ASSET__5nP20sXz__"